import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { BASE_URL } from './../../../config';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';

const token = localStorage.getItem('token');

const FrmEscenario = ({ showModal, handleCloseModal, escenario = null, onAddEquipos, onUpdateEquipos }) => {
    const [nombreEscenario, setNombreEscenario] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [idSede, setIdSede] = useState(''); // Cambiado a idSede
    const [urlImagen, setImagen] = useState(null);
    const [sedes, setSedes] = useState([]);

    useEffect(() => {
        const fetchSedes = async () => {
            try {
                const response = await axios.get(`${BASE_URL}sedes`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setSedes(response.data);
            } catch (error) {
                console.error('Error al cargar las sedes:', error);
            }
        };

        if (escenario) {
            setNombreEscenario(escenario.nombreEscenario || '');
            setDescripcion(escenario.descripcion || '');
            setIdSede(escenario.idSede || '');
            setImagen(escenario.urlImagen || '');
        }

        fetchSedes();
    }, [escenario]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagen(file);
        }
    };

    const handleSelectChange = (event) => {
        const selectedId = event.target.value;
        setIdSede(selectedId);
    };

    const createOrUpdateEscenary = async () => {
        const formData = new FormData();
        formData.append('nombreEscenario', nombreEscenario);
        formData.append('descripcion', descripcion);
        formData.append('idSede', idSede);
        formData.append('file', urlImagen);

        if (!nombreEscenario || !idSede) {
            toast.error('Debes al menos enviar el nombre del escenario y la sede');
            return;
        }

        try {
            if (escenario && escenario.id) {
                const response = await axios.post(`${BASE_URL}escenarios/${escenario.id}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 200) {
                    onUpdateEquipos(response.data);
                    handleCloseModal();
                    toast.success('Escenario actualizado exitosamente');
                }
            } else {
                const response = await axios.post(`${BASE_URL}escenarios`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.status === 201) {
                    toast.success('Escenario creado exitosamente');
                    onAddEquipos(response.data);
                    handleCloseModal();
                }
            }
        } catch (error) {
            toast.error('Ocurrió un error inesperado, inténtalo de nuevo más tarde');
        }
    };

    return (
        <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>{escenario ? 'Actualizar Escenario' : 'Agregar Escenario'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form>
                    <div className="form-group">
                        <label htmlFor="nombreEscenario">Nombre del Escenario</label>
                        <input
                            type="text"
                            id="nombreEscenario"
                            className="form-input"
                            placeholder="Nombre del Escenario"
                            value={nombreEscenario}
                            onChange={(e) => setNombreEscenario(e.target.value)}
                            required
                        />
                    </div>

                    <Form.Group controlId="formSelect">
                        <Form.Label>Selecciona una sede</Form.Label>
                        <Form.Select value={idSede} onChange={handleSelectChange}>
                            <option value="">Selecciona...</option>
                            {sedes.map((sede) => (
                                <option key={sede.id} value={sede.id}>
                                    {sede.nombreSede}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <div className="form-group mt-2">
                        <label htmlFor="imagen" className="file-label">Subir imagen del escenario</label>
                        <input
                            type="file"
                            id="imagen"
                            className="form-input file-input"
                            onChange={handleImageChange}
                            accept="image/*"
                        />
                    </div>

                    {urlImagen && (
                        <div className="image-preview-container">
                            <h5>Vista previa:</h5>
                            <img
                                src={urlImagen instanceof File ? URL.createObjectURL(urlImagen) : urlImagen}
                                alt="Vista previa"
                                className="image-preview"
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="descripcion">Descripción</label>
                        <textarea
                            id="descripcion"
                            className="form-input"
                            placeholder="Descripción del Escenario"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                    Cerrar
                </Button>
                <Button variant="primary" onClick={createOrUpdateEscenary}>
                    {escenario ? 'Actualizar' : 'Agregar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export { FrmEscenario };
